import { lazy } from 'react';
import { Home, ScrollText, Shield, Settings, Boxes, Bot } from 'lucide-react';
import { defineFrontendModule } from './types';
import { registerGeneralWidgets } from '../../modules/general/widgets';

/** Pages of the core: dashboard and administration. */
export const coreModule = defineFrontendModule({
  id: 'core',
  name: 'Kern',

  routes: [
    { path: '', element: lazy(() => import('../../pages/Dashboard')) },
    { path: 'suche', element: lazy(() => import('../search/SearchPage')) },
    { path: 'admin/settings', menuKey: 'admin.settings', element: lazy(() => import('../../pages/Settings')) },
    { path: 'admin/logs', menuKey: 'admin.logs', element: lazy(() => import('../../pages/Logs')) },
    { path: 'admin/menu-permissions', menuKey: 'admin.menu-permissions', element: lazy(() => import('../../pages/MenuPermissions')) },
    { path: 'admin/modules', menuKey: 'admin.modules', element: lazy(() => import('../../pages/Modules')) },
    { path: 'admin/mcp', menuKey: 'admin.mcp', element: lazy(() => import('../../pages/McpOverview')) },
  ],

  nav: [
    { menuKey: 'dashboard', path: '/', defaultIcon: Home },
    {
      menuKey: 'admin',
      defaultIcon: Settings,
      items: [
        { menuKey: 'admin.logs', path: '/admin/logs', label: 'API-Logs', icon: ScrollText },
        { menuKey: 'admin.menu-permissions', path: '/admin/menu-permissions', label: 'Menü-Berechtigungen', icon: Shield },
        { menuKey: 'admin.settings', path: '/admin/settings', label: 'Konfiguration', icon: Settings },
        { menuKey: 'admin.modules', path: '/admin/modules', label: 'Module', icon: Boxes },
        { menuKey: 'admin.mcp', path: '/admin/mcp', label: 'MCP-Server', icon: Bot },
      ],
    },
  ],

  registerWidgets: registerGeneralWidgets,
});
